/** Shows the featured products one slide at a time: on a timer, with the arrows, the bars and by swiping. */
document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-product-carousel-track]');
  const bars = [...carousel.querySelectorAll('[data-product-carousel-bar]')];
  const count = track.children.length;
  let active = 0;
  // The slide the timer or a click is scrolling to; the slides it passes on the way are skipped.
  let destination = null;

  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  // The bar of the active slide fills up. base.css times it, and holds it while someone reads.
  const activate = (index) => {
    active = index;
    bars.forEach((bar, position) => bar.toggleAttribute('data-active', position === index));
  };
  const show = (index) => {
    const slide = (index + count) % count;
    destination = slide === current() ? null : slide;
    activate(slide);
    track.scrollTo({ left: slide * track.clientWidth });
  };

  track.addEventListener('scroll', () => {
    const slide = current();
    if (destination !== null) {
      if (slide === destination) {
        destination = null;
      }
      return;
    }
    if (slide !== active) {
      activate(slide);
    }
  });
  // Swiping takes over from a slide that is still on its way.
  ['pointerdown', 'touchstart', 'wheel'].forEach((type) => {
    track.addEventListener(
      type,
      () => {
        destination = null;
      },
      { passive: true }
    );
  });

  carousel.querySelectorAll('[data-product-carousel-step]').forEach((button) => {
    button.addEventListener('click', () => show(active + Number(button.dataset.productCarouselStep)));
  });
  bars.forEach((bar, index) => {
    bar.addEventListener('click', () => show(index));
    // A full bar is the timer: on to the next product.
    bar.addEventListener('animationend', () => show(index + 1));
  });
});
